import { Component, DestroyRef, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemeService } from '../../core/services/theme.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-theme-toggle',
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss'
})
export class ThemeToggleComponent implements OnInit {
  currentTheme = 'light';

  constructor(private themeService: ThemeService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit(): void {
    this.themeService.theme$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  setTheme(theme: string): void {
    this.themeService.setTheme(theme);
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
